import { SxProps } from "@mui/material";

export const sxTypographyTitle: SxProps = {
  fontFamily: 'UnimedSans-bold',
  color: '#000',
  fontWeight: 700,
  fontSize: 24,
  marginBottom: '10px'
}
export const sxIconButton: SxProps = {
  //border: '2px solid white',
  marginLeft: '10px',
  /*   transition: 'all 0.3s ease', */
  '&:hover': {
    backgroundColor: "#88b856",
  }
}

export const sxBeneficiarioInfo: SxProps = {
  fontFamily: 'UnimedSans-bold',
  color: '#000',
  fontWeight: 700,
  fontSize: 14,
}
export const sxBeneficiarioInfoLabel: SxProps = {
  fontSize: 12,
  color: '#000',
}

export const sxBeneficiarioMoreInfo: SxProps = {
  fontFamily: 'UnimedSans-bold',
  color: '#FFFFFF',
  fontWeight: 700,
  fontSize: 14,
}
export const sxBeneficiarioMoreInfoLabel: SxProps = {
  fontSize: 12,
  color: '#FFFFFF'
}

export const sxNumeroCartao: SxProps = {
  fontFamily: 'UnimedSans-bold',
  color: '#2F2F32',
  fontWeight: 700,
  fontSize: 24,
}

export const sxInfoHeaderCartao: SxProps = {
  fontFamily: 'UnimedSans-bold',
  color: '#fff',
  fontWeight: 700,
  fontSize: 16,
  textAlign: 'center'
}

export const sxInfoBodyCartaoVerso: SxProps = {
  color: '#2F2F32',
  fontSize: 12,
}

export const sxInfoNoCard: SxProps = {
  color: '#545459',
  fontSize: 18,
}

export const sxInfoBodyCartaoVersoBold: SxProps = {
  color: '#2F2F32',
  fontSize: 14,
  fontFamily: 'UnimedSans-bold',
}

export const sxLabelInfoBeneficiario: SxProps = {
  color: '#4C4C4C',
  fontSize: 16,
  fontFamily: 'UnimedSans-bold',
}

export const sxInfoBeneficiario: SxProps = {
  color: '#4C4C4C',
  textTransform: 'capitalize',
  fontSize: 16,
}

export const sxDivider: SxProps = {
  margin: '32px 0px 32px 0px'
}

export const sxTextButtonQr: SxProps = {
  textAlign: 'start',
  color: 'white',
  fontSize: 16,
  fontFamily: 'UnimedSans-bold',
  textTransform: "none",
  marginRight: '16px',
}

export const sxTextSwitch: SxProps = {

  color: '#545459',
  fontSize: 16,
  fontFamily: 'UnimedSans-Regular-Italic'
}

export const sxTitleQrCode: SxProps = {
  fontSize: 20,
  fontFamily: 'UnimedSans-bold',
  color: '#383838'
}

export const sxSubTitleQrCode: SxProps = {
  fontSize: 16,
  color: '#717171',
  textAlign: 'center'
}


export const sxTokenQrCode: SxProps = {
  fontSize: 20,
  color: '#00995D',
  textAlign: 'center'
}

export const sxQrCodeButton: SxProps = {
  /*   color: 'rgba(0, 0, 0, 0.08)',
    '&:hover': {
      boxShadow: '0px 4px 50px 0px',
      backgroundColor: '#FFF'
    },
    display: 'flex',
    justifyContent: 'start',
    padding: '20px 24px', */
  borderRadius: '80px',
  height: '44px',
  padding: '24px 32px',
}